export default [
    {
        type: "none",
        label: ""
    },
    {
        type: "split",
        label: "Split into an array"
    },
    {
        type: "splitValues",
        label: "Split into context properties"
    },
    {
        type: "randomInt",
        label: "Random Integer"
    },
    {
        type: "currentHourTZ",
        label: "Current Hour"
    },
    {
        type: "currentMinuteTZ",
        label: "Current Minute"
    },
    {
        type: "currentDayOfTheWeekTZ",
        label: "Current Day of Week"
    },
    {
        type: "userProperty",
        label: "User property "
    },
    {
        type: "lookup",
        label: "Lookup"
    },
    {
        type: "lowercase",
        label: "Lowercase"
    },
    {
        type: "uppercase",
        label: "Uppercase"
    },
    {
        type: "arrayLength",
        label: "Length Array"
    },
    {
        type: "stringLength",
        label: "Length String"
    },
    {
        type: "indexOf",
        label: "Index of"
    },
    {
        type: "nElement",
        label: "Nth Element"
    },
    {
        type: "indexOfArray",
        label: "Index of array"
    },
    {
        type: "nElementArray",
        label: "Nth Element array"
    },
    {
        type: "regex",
        label: "Regex"
    },
    {
        type: "inputCount",
        label: "Input Count"
    },
    {
        type: "parseDate",
        label: "Parse date"
    },
    {
        type: "arrayLimit",
        label: "Array limit"
    },
    {
        type: "replace",
        label: "Replace"
    },
    {
        type: "stringJoin",
        label: "String join"
    },
    {
        type: "substring",
        label: "Substring"
    },
    {
        type: "itemPosition",
        label: "Item Position"
    }
];